import { IconImageM } from "@common/components/icons/IconsM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { useNavigation } from "@react-navigation/native"
import React, { useContext } from "react"
import { Dimensions, View } from "react-native"
import { IconButton } from "react-native-paper"
import { SafeAreaView, useSafeAreaInsets } from "react-native-safe-area-context"
import { connect } from "react-redux"
import { apiIdle, apiRequest } from "../../../data/redux/actions/api"
import { findItemInListWithId } from "../../../data/utility/dataUtils"
import { TodoActivityBadges } from "../../organize/list/TodoActivityBadges"
import { DoneChip } from "../read/DoneChip"
import TodoIcon from "../todo/TodoIcon"

const StaticOneStepActivityHeader = (props) => {
    const { activity, onExit, route } = props

    const navigation = useNavigation()
    const dimensions = useContext(DimensionsContext)
    const insets = useSafeAreaInsets()

    const schoolSubject = findItemInListWithId(
        activity?.school_subject_id,
        props.schoolSubjects
    )

    const activityTemplate = props.activityTemplates?.find(
        (s) => s?.id === activity?.activity_template_id
    )

    const activityItem = () => {
        if (!activity) {
            return null
        }

        return (
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    flex: 1,
                }}
            >
                <View
                    style={{
                        marginLeft: 3,
                    }}
                >
                    <TextM fontWeight={"SemiBold"} fontSize={14}>
                        {activity?.material?.title ?? activity?.title}
                    </TextM>
                    <View style={{
                        alignItems: "center",
                        flexDirection: "row",
                    }}>
                        <IconImageM
                            uri={schoolSubject?.icon}
                            width={9}
                            style={{
                                marginRight: 4,
                            }}
                        />
                        <TextM
                            fontWeight="Light"
                            color={schoolSubject?.color}
                            style={{}}
                            fontSize={9}
                        >
                            {activity?.student_chapter?.chapter?.name
                                ? activity?.student_chapter?.chapter?.name
                                : schoolSubject?.name}
                        </TextM>
                    </View>
                </View>
            </View>
        )
    }

    const statusActivity = activity?.status

    return (
        <View
            style={{
                width: Dimensions.get("window").width,
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: theme.colors.white,
                borderBottomWidth: 1,
                borderColor: theme.colors.lightMore,
                paddingTop: insets.top,
            }}
        >
            <View
                style={{
                    width: dimensions?.width,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: 65,
                }}
            >
                <View
                    style={{
                        flex: 1,
                        flexDirection: "row",
                        alignItems: "center",
                        marginLeft: 10,
                    }}
                >
                    {!props.isLiveMode && (
                        <IconButton
                            icon={"arrow-left"}
                            iconColor={theme.colors.primary}
                            size={32}
                            onPress={onExit}
                        />
                    )}
                    {props.isLiveMode && (
                        <TodoIcon
                            width={48}
                            navigation={navigation}
                            route={route}
                        />
                    )}
                    {activityItem()}
                </View>
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        paddingRight: 8,
                    }}
                >
                    {activity && (
                        <View
                            style={{
                                flexDirection: "column",
                                alignItems: "flex-end",
                                justifyContent: "center",
                            }}
                        >
                            <DoneChip
                                count={0}
                                status={statusActivity}
                                style={{ marginRight: 10}}
                                noText
                            />
                            <TodoActivityBadges
                                activity={activity}
                                noDifficulty
                                custom
                                style={{ marginRight: 10, marginTop: 2 }}
                            />
                        </View>
                    )}
                </View>
            </View>
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        schoolSubjects: state.data.staticData?.school_subjects,
        activityTemplates: state.data.staticData?.activity_templates,
        isLiveMode: state.liveMode.isLiveModeEnabled,
        todayLiveSessionLogs: state.liveMode?.todayLiveSessionLogs,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StaticOneStepActivityHeader)
